<template>
	<div class="uploadBox"></div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import "../../../../common/aws-sdk-2.235.1.min.js";
export default {
	data() {
		return {
			bucket: "", //aws上传接口
			bucketname: "ccrb", //桶
			uploadid: "",
			partsize: 1 * 1024 * 1024, //1MB  分片
			filestate: {
				status: "", //有 error（直接报错） 和 fail（上传的时候报错） 和 success（上传成功） 和 processing（上传中）
				percent: "", //（0-100的进度）
			},
		};
	},
	watch: {
		filestate() {
			console.log(this.filestate);
		},
	},
	methods: {
		//--------------------------分断上传保证稳定性
		//初始化上传
		// async init(){
		// 	const credentials = {
		// 	    accessKeyId: "AKIATLPEDU37QV5CHLMH",
		// 	    secretAccessKey: "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",
		// 	}; //秘钥形式的登录上传
		// 	window.AWS.config.update(credentials);
		// 	window.AWS.config.region = "cn-northwest-1"; //设置区域
		// 	//桶的设置
		// 	bucket = new window.AWS.S3({
		// 	    params: {
		// 	        Bucket: this.bucketname
		// 	    }
		// 	});
		// 	return bucket;
		// },
		// 初始化上传入口
		async initMultipartUpload(key) {
			const params = {
				Bucket: this.bucketname,
				Key: key,
			};
			//创建一个续传通道
			const data = await this.bucket.createMultipartUpload(params).promise();
			return data.UploadId;
		},
		// 上传文件的某一部分
		async uploadPart(file, keyname, uploadid, pn, start, end) {
			//key可以设置为桶的相对路径，Body为文件， ACL最好要设置
			var params = {
				Bucket: this.bucketname,
				Key: keyname,
				// ContentType: file.type,
				PartNumber: pn,
				UploadId: uploadid,
				Body: file.slice(start, end),
				// "Access-Control-Allow-Credentials": "*",
				// ACL: "public-read",
			};
			const result = await this.bucket.uploadPart(params).promise();
			// .then((data) => {
			return { ETag: result.ETag, PartNumber: pn };
			// })
			// .catch((err) => {
			//     return err;
			// });
		},
		//完成分块上传
		async completeMultipartUpload(parts, keyname) {
			const params = {
				Bucket: this.bucketname,
				Key: keyname,
				MultipartUpload: { Parts: parts },
				UploadId: this.uploadid
			};
			return await this.bucket.completeMultipartUpload(params).promise();
		},
		async abortMultipartUpload(key, uploadid) {
			const params = {
				Bucket: this.bucketname,
				Key: key,
				UploadId: uploadid,
			};
			await this.bucket.abortMultipartUpload(params).promise();
		},
		// 实际的上传逻辑
		async uploadFile(file, folderid) {
			folderid = folderid || uuidv4(); //分配到一个随机的id里
			var keyname = folderid + "/" + file.name; //保存在指定的文件夹里
			this.uploadid = "";
			try {
				this.init(); // 初始化aws接口
				// 初始化分块上传
				this.uploadid = await this.initMultipartUpload(keyname);
				// 分块上传文件
				let parts = [];
				let start = 0;
				let end = 0;
				let len = Math.ceil(file.length / this.partsize); //循环的长度
				//循环上传
				for (let i = 0; i < len; i++) {
					start = i * this.partsize;
					end = (i + 1) * this.partsize;
					parts.push(
						await uploadPart(file, keyname, this.uploadid, i, start, end)
					);
				}
				// 完成分块上传
				await this.completeMultipartUpload(parts, this.uploadid);
				return this.uploadid;
			} catch (error) {
				// 如果出现错误，中止分块上传
				console.error("An error occurred during file upload:", error);
				await abortMultipartUpload(keyname, this.uploadid);
			}
		},
		//--------------------------------下面支持断点续传

		//初始化亚马逊参数
		async init() {
			//秘钥形式的登录上传
			const credentials = {
				accessKeyId: "AKIATLPEDU37QV5CHLMH",
				secretAccessKey: "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",
				region: "cn-northwest-1",
			};
			window.AWS.config.update(credentials);
			// window.AWS.config.region = "cn-northwest-1"; //设置区域
			//桶的设置
			this.bucket = new window.AWS.S3({
				params: {
					Bucket: this.bucketname,
				},
			});
			return this.bucket;
		},

		//获取当前文件是否有已上传断点信息
		async getawscheckpoint(key) {
			let partsinfo;
			try {
				const result = await this.bucket
					.listMultipartUploads({ Bucket: this.bucketname, Prefix: key })
					.promise();
				//获取具体分片信息
				if (result.Uploads.length) {
					this.uploadid = result.Uploads[result.Uploads.length - 1].UploadId;
					partsinfo = await this.bucket
						.listParts({
							Bucket: this.bucketname,
							Key: key,
							UploadId: this.uploadid,
						})
						.promise();
				}
			} catch (err) {
				console.log(err);
			}
			return { uploadid: this.uploadid, partsinfo };
		},

		//分段上传
		async awsuploadpart(filestate, file, uploadid, parts, key) {
			var partarr = []; //已完成的数组
			//已完成的分片,转化成提交格式
			const completeparts = parts.map((_) => {
				partarr.push(_.PartNumber);
				return { PartNumber: _.PartNumber, ETag: _.ETag };
			});
			// 分块上传文件
			// parts = [];
			let uploadpart;
			let start = 0;
			let end = 0;
			let len = Math.ceil(file.size / this.partsize); //循环的长度
			if (partarr.length) {
				this.filestate.status = "processing";
				this.filestate.percent = parseInt((completeparts.length * 100) / len);
			}
			//循环上传
			for (let i = 0; i < len; i++) {
				start = i * this.partsize;
				end = (i + 1) * this.partsize;
				if (!partarr.includes(i)) {
					uploadpart = await this.uploadPart(
						file,
						key,
						uploadid,
						i + 1,
						start,
						end
					);
					if (uploadpart.ETag != null) {
						completeparts.push(uploadpart);
						this.filestate.percent = parseInt(
							(completeparts.length * 100) / len
						);
					} else {
						this.filestate.status = "fail";
						return;
					}
				}
			}
			//提交上传成功信息
			let data = await this.completeMultipartUpload(completeparts, uploadid);
			this.filestate.status = "success";
			return data;
		},

		//上传的接口
		async awsupload(file, folderid) {
			debugger;
			this.init(); //初始化桶
			const key = (folderid || uuidv4()) + "/" + file.name; //需要上传的文件名
			this.filestate.percent = 0;
			this.filestate.status = "start";
			//上传的参数
			var params = {
				Bucket: this.bucketname,
				Key: key,
			};
			//设置桶上传文件
			try {
				//检查文件是否已上传
				this.bucket.headObject(params, async (err, data) => {
					// 没有上传成功，head方法会返回失败
					if (err) {
						//检查是否部分上传
						const { uploadid, partsinfo } = await this.getawscheckpoint(
							key,
							this.bucket
						);
						console.log(uploadid);
						//如果已经部分存在，那么直接在节点续传
						if (uploadid) {
							//断点续传
							this.awsuploadpart(
								this.filestate,
								file,
								uploadid,
								partsinfo.Parts,
								key
							);
						}
						//不存在，上传新的
						else {
							const uploadid = await this.initMultipartUpload(key); //初始化文件上传
							this.awsuploadpart(this.filestate, file, uploadid, [], key);
						}
					}
					//如果已经上传成功了，那么直接返回状态百分百
					else if (data) {
						//data存在，上传成功
						console.log(data);

						this.filestate.percent = 100;
						this.filestate.status = "success";
					}
				});
			} catch (err) {
				this.filestate.status = "error";
				console.log(err);
			}
			return this.filestate;
		},
	},
	mounted() {},
};
</script>

<style scoped>
.uploadBox {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/csTest/component/uploadFile.vue